/**
 * @desc Item collection structure possesses both
 *       - the pop behavior of a queue (pop)
 *       - the pop behavior of stack (popFirst)
 */
export class StackQueue<T> {
  private _data = [];

  constructor(items: T[] = []) {
    this._data = [...items];
  }

  push(item: T) {
    this._data.push(item);
  }

  pop(): T {
    return this._data.pop();
  }

  popFirst() {
    const value = this._data[0];
    this._data.shift();
    return value;
  }

  get length() {
    return this._data.length;
  }

  get items() {
    return this._data;
  }
}
